import type { ReactNode } from 'react';

/**
 * Creates a new option object with a custom label and value, marking it as a new entry.
 *
 * @typeParam Option - The type of the option object to return. Defaults to `unknown`.
 * @param inputValue - The string value to assign to the `value` property of the new option.
 * @param optionLabel - The label to display for the new option, as a ReactNode.
 * @returns A new option object with `__isNew__` set to `true`, and the specified `label` and `value`.
 */
export const newOption = <Option = unknown>(inputValue: string, optionLabel: ReactNode): Option => {
  return {
    __isNew__: true,
    label: optionLabel,
    value: inputValue,
  } as Option;
};
